/**
 * Prova-på (anmälning trial) members stay in Approval Center until photo review,
 * but may use the app while reviewed === false (silent review).
 * Signup registrations without this flag still wait for admin approval.
 */
export function memberHasSilentProvaPaAccess(user) {
  return Boolean(user?.provaPaSilentPhotoReview);
}

/** Treat as "reviewed" for menus and landing access (not admin approval semantics). */
export function memberReviewedForMemberUi(user) {
  if (!user) return false;
  if (user.reviewed === true) return true;
  if (memberHasSilentProvaPaAccess(user)) return true;
  return false;
}

export function memberCanUseMemberMenus(user) {
  return memberReviewedForMemberUi(user) || (user?.rejected === true && user?.allowEdit === true);
}
